<ng-select [clearable]="false" (change)="changeLanguage($event)" [items]="languages" [(ngModel)]="selectedLanguageCode" bindLabel="name" bindValue="code">
  <ng-template ng-label-tmp let-item="item"> {{ item.name }} {{ item.min }} </ng-template>
  <ng-template ng-option-tmp let-item="item" let-index="index"> {{ item.name }} {{ item.min }} </ng-template>
</ng-select>
